import { render, staticRenderFns } from "./viceService.vue?vue&type=template&id=f2d33d5e&scoped=true"
import script from "./viceService.vue?vue&type=script&lang=js"
export * from "./viceService.vue?vue&type=script&lang=js"
import style0 from "./viceService.vue?vue&type=style&index=0&id=f2d33d5e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d33d5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2d33d5e')) {
      api.createRecord('f2d33d5e', component.options)
    } else {
      api.reload('f2d33d5e', component.options)
    }
    module.hot.accept("./viceService.vue?vue&type=template&id=f2d33d5e&scoped=true", function () {
      api.rerender('f2d33d5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serviceCenter/viceService.vue"
export default component.exports